/** Badge/chip styles using theme colors defined up to *-900 (not *-950). */

export const STATUS_BADGE_STYLES: Record<string, string> = {
  OPEN:
    'bg-emerald-100 text-emerald-800 ring-1 ring-emerald-200 dark:bg-emerald-900/50 dark:text-emerald-200 dark:ring-emerald-600',
  ANSWERED:
    'bg-blue-100 text-blue-800 ring-1 ring-blue-200 dark:bg-blue-900/50 dark:text-blue-200 dark:ring-blue-600',
  CLOSED:
    'bg-slate-200 text-slate-600 ring-1 ring-slate-300 dark:bg-gray-800 dark:text-gray-200 dark:ring-gray-600',
};

export const CONCLUSION_BADGE_STYLES: Record<string, string> = {
  AGREE:
    'bg-emerald-100 text-emerald-800 ring-1 ring-emerald-200 dark:bg-emerald-900/50 dark:text-emerald-200 dark:ring-emerald-600',
  DISAGREE:
    'bg-red-100 text-red-800 ring-1 ring-red-200 dark:bg-red-900/50 dark:text-red-200 dark:ring-red-600',
  UNCERTAIN:
    'bg-amber-100 text-amber-800 ring-1 ring-amber-200 dark:bg-amber-900/50 dark:text-amber-200 dark:ring-amber-600',
  NEED_MORE_INFO:
    'bg-blue-100 text-blue-800 ring-1 ring-blue-200 dark:bg-blue-900/50 dark:text-blue-200 dark:ring-blue-600',
};

export const CONCLUSION_CHIP_IDLE: Record<string, string> = {
  AGREE:
    'border-emerald-300 bg-emerald-100 text-emerald-800 hover:bg-emerald-200 dark:border-emerald-600 dark:bg-emerald-900/50 dark:text-emerald-200 dark:hover:bg-emerald-900/70',
  DISAGREE:
    'border-red-300 bg-red-100 text-red-800 hover:bg-red-200 dark:border-red-600 dark:bg-red-900/50 dark:text-red-200 dark:hover:bg-red-900/70',
  UNCERTAIN:
    'border-amber-300 bg-amber-100 text-amber-800 hover:bg-amber-200 dark:border-amber-600 dark:bg-amber-900/50 dark:text-amber-200 dark:hover:bg-amber-900/70',
  NEED_MORE_INFO:
    'border-blue-300 bg-blue-100 text-blue-800 hover:bg-blue-200 dark:border-blue-600 dark:bg-blue-900/50 dark:text-blue-200 dark:hover:bg-blue-900/70',
};
